import { createGlobalStyle } from 'styled-components';
import theme from 'theme/theme';

const GlobalStyles = createGlobalStyle`
    font-size: 16px;

    * {
        font-size: 16px;
        font-family: ${theme.primaryFont};
        box-sizing: border-box;
        color: ${theme.text1};
        font-weight: 600;
        box-sizing: border-box;
    }

    html {
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        font-variant-ligatures: contextual common-ligatures;
    }

    html, body, #root{
        margin: 0;
        padding: 0;
        background-color: ${theme.background1};
        overflow-x: hidden;
    }

    @media (prefers-reduced-motion: no-preference) {
        html {
            scroll-behavior: smooth;
        }
    }

    h1 {
        margin: 0;
        font-family: ${theme.headerFont};
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${theme.text2};
        text-overflow: ellipsis !important;
        font-size: 16px;
        opacity: 1; /* Firefox */
      }
      
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${theme.text2};
    }
    
    ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${theme.text2};
    }
`;

export default GlobalStyles;
